import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { Button, DialogActions } from "@mui/material";
import PlaceSearch from "../../../AddNewCargoPage/PlaceSearch/PlaceSearch";
import { useState } from "react";
import {
  SearchOption,
  SearchResultSearchOption,
  ReverseGeocodeSearchOption,
  SavedLocationSearchOption,
} from "../../../AddNewCargoPage/PlaceSearch/SearchOption";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../../redux-store";
import { updateCargoStop } from "../../../../ducks/app/update-cargo";
import { LookupResult } from "dora-shared";
import { Latitude, Longitude } from "dora-contracts";

type EditAddressDialogProps = {
  cargoId: string;
  stopId: string;
  onClose: () => void;
};

const EditAddressDialog = (props: EditAddressDialogProps) => {
  const { cargoId, stopId, onClose } = props;
  const { t } = useTranslation("stopPage");
  const dispatch = useAppDispatch();

  const [isSaving, setIsSaving] = useState(false);
  const [searchLocation, setSearchLocation] = useState<
    | SearchResultSearchOption
    | SavedLocationSearchOption
    | ReverseGeocodeSearchOption
    | null
  >(null);

  const onSaveButtonClick = async () => {
    try {
      setIsSaving(true);
      let result: LookupResult;
      if (searchLocation!.type === "SAVED_LOCATION") {
        result = {
          ...searchLocation!.value.data.place,
          countryCode: searchLocation!.value.data.place.country || "",
          placeName: searchLocation!.value.data.place.placeName || "",
          address: searchLocation!.value.data.place.address || "",
          city: searchLocation!.value.data.place.city || "",
          postcode: searchLocation!.value.data.place.postcode || "",
          coords: {
            lat: searchLocation!.value.data.place.coord.lat,
            lon: searchLocation!.value.data.place.coord.lon,
          },
        };
      } else {
        result = await searchLocation!.value.data.lookup();
      }
      await dispatch(
        updateCargoStop({
          cargoId,
          stopId,
          data: {
            place: {
              ...result,
              country: result.countryCode,
              position: {
                lat: result.coords.lat as Latitude,
                lon: result.coords.lon as Longitude,
              },
            },
          },
        })
      );
      onClose();
    } catch (e) {
      console.error(e);
      setIsSaving(false);
    }
  };

  const onPlaceChange = (newPlace: SearchOption | null) => {
    setSearchLocation(newPlace as any);
  };

  return (
    <Dialog fullWidth open onClose={() => !isSaving && onClose()}>
      <DialogTitle>{t("editDialogs.addressTitle")}</DialogTitle>
      <DialogContent>
        <PlaceSearch
          label={t("editDialogs.addressLabelPlaceholder")}
          location={searchLocation}
          onLocationChangedManually={() => {}}
          onLocationChange={onPlaceChange}
        />
      </DialogContent>
      <DialogActions className="mx-4 mb-2">
        <Button
          disabled={isSaving}
          onClick={onClose}
          variant="outlined"
          size="large"
          fullWidth
        >
          {t("editDialogs.cancelButton")}
        </Button>
        <Button
          disabled={isSaving}
          onClick={onSaveButtonClick}
          variant="contained"
          fullWidth
          size="large"
        >
          {t("editDialogs.saveButton")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditAddressDialog;
